<template src="./PushMessage.html"></template>

<script>
export default {
  data() {
    return {
      dataBody: "",
      dataToMessage: [],
      titlePush: null,
    };
  },
  methods: {
    sendData() {
      this.$store.dispatch("setCargando", true);
      try {
        if (confirm("¡Está seguro de enviar este mensaje!")) {
          this.dataToMessage = {
            template: "no_aplica",
            body: this.dataBody,
            title: this.titlePush,
            type: "text",
          };
          this.$emit("dataToSend", this.dataToMessage);
        } else {
          this.$store.dispatch("setCargando", false);
        }
      } catch (error) {
        console.log(error);
      }
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style src="./PushMessage.scss" lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/MensajesMasivos/PushMessage/PushMessage.vue